module.exports = __webpack_public_path__ + "static/feature-b759d87ac26fe1fb9a193ec228a4e9f5.png";